<script setup>
import { onMounted, onUnmounted, ref } from "vue"
import { useRouter } from "vue-router"
import api from "@/api/axios.js"

const router = useRouter()
const totalNoLeidas = ref(0)
const notificaciones = ref([])
const abierto = ref(false)
let intervalo = null

async function cargarContador() {
  try {
    const { data } = await api.get("/notificaciones/no-leidas-count")
    totalNoLeidas.value = data.total
  } catch (err) {
    console.error(err)
  }
}

async function cargarNotificaciones() {
  try {
    const { data } = await api.get("/notificaciones")
    notificaciones.value = data.notificaciones
  } catch (err) {
    console.error(err)
  }
}

async function alternar() {
  abierto.value = !abierto.value
  if (abierto.value) await cargarNotificaciones()
}

async function irANotificacion(n) {
  if (!n.leida) {
    try {
      await api.put(`/notificaciones/${n.id}/leida`)
      n.leida = true
      await cargarContador()
    } catch (err) {
      console.error(err)
    }
  }

  abierto.value = false
  if (n.entidadTipo === "cita" && n.entidadId) {
    router.push({ name: "CitasMisCitas" })
  }
}

function formatFecha(value) {
  return new Date(value).toLocaleString("es-CO", { dateStyle: "short", timeStyle: "short" })
}

onMounted(() => {
  cargarContador()
  intervalo = setInterval(cargarContador, 30000)
})

onUnmounted(() => {
  if (intervalo) clearInterval(intervalo)
})
</script>

<template>
  <li class="nav-item ps-3 d-flex align-items-center position-relative">
    <a href="#" class="p-0 nav-link text-white position-relative" @click.prevent="alternar">
      <i class="ni ni-bell-55" style="font-size: 1.1rem;"></i>
      <span
        v-if="totalNoLeidas > 0"
        class="badge bg-danger rounded-pill position-absolute"
        style="top: -6px; right: -8px; font-size: 0.6rem;"
      >
        {{ totalNoLeidas > 9 ? "9+" : totalNoLeidas }}
      </span>
    </a>

    <div v-if="abierto" class="dropdown-menu dropdown-menu-end show notificaciones-dropdown" @click.stop>
      <h6 class="dropdown-header">Notificaciones</h6>
      <div v-if="notificaciones.length === 0" class="dropdown-item-text text-muted text-sm">
        No tienes notificaciones.
      </div>
      <a
        v-for="n in notificaciones"
        :key="n.id"
        href="#"
        class="dropdown-item"
        :class="{ 'fw-bold': !n.leida }"
        @click.prevent="irANotificacion(n)"
      >
        <div class="text-sm">{{ n.titulo }}</div>
        <div class="text-xs text-muted text-wrap">{{ n.mensaje }}</div>
        <div class="text-xs text-muted">{{ formatFecha(n.createdAt) }}</div>
      </a>
    </div>
  </li>
</template>

<style scoped>
.notificaciones-dropdown {
  display: block;
  /* Bootstrap trae ".navbar-nav .dropdown-menu{position:static}" para
     cuando el navbar SÍ colapsa detrás de un toggle en mobile (ahí el
     dropdown se ve inline, como parte del menú expandido) — acá el navbar
     nunca colapsa así, así que ese caso no aplica y solo rompe el layout
     (empuja todo el contenido en vez de flotar). Empata en especificidad
     con esta regla y gana por venir después en la hoja compilada; el
     !important es la forma mínima de ganarle sin tocar nada de Bootstrap. */
  position: absolute !important;
  top: 100%;
  right: 0;
  /* 320px en pantallas normales, igual que antes; en viewports angostos
     (<~344px) se achica para no desbordar el borde izquierdo. */
  width: min(320px, calc(100vw - 1.5rem));
  max-height: 400px;
  overflow-y: auto;
  z-index: 1060;
}
</style>
